// extracted by mini-css-extract-plugin
export var header = "_wt-1";
export var maskBottom = "_wt-6";
export var maskMiddle = "_wt-7";
export var maskTop = "_wt-5";
export var root = "_wt-0";
export var scrollDownButton = "_wt-3";
export var scrollDownButtonHidden = "_wt-4";
export var viewport = "_wt-2";